import React from 'react';
import './quick-link-card.scss';
import { Typography, Box } from '@mui/material';

export default function QuickLinksCard(props) {
  const { templateID, url, image, heading } = props;

  const renderCoverLayout = (align) => (
    <a className="QuickLinksCardContainer QuickLinksCard--cover" href={url}>
      <img
        className="QuickLinksCardImage QuickLinksCardImage--cover"
        src={`/CmsImages/${image}`}
        alt={`${heading} Icon`}
      />
      <Typography
        className={`QuickLinksCard__overlay QuickLinksCard__overlay--${align}`}
        variant="subtitle1"
      >
        {heading}
      </Typography>
    </a>
  );

  const renderSideLayout = (reverse) => (
    <a
      className={`QuickLinksCardContainer${reverse ? ' QuickLinksCardContainer--reverse' : ''}`}
      href={url}
    >
      <Box
        sx={{
          display: 'flex',
          height: '100%',
          flex: '0 0 auto',
          objectFit: 'contain',
          width: '75px',
        }}
      >
        <img
          className={`QuickLinksCardImage QuickLinksCardImage--${reverse ? 'right' : 'left'}`}
          src={`/CmsImages/${image}`}
          alt={`${heading} Icon`}
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flex: '1',
          textAlign: 'center',
          padding: '0.5em',
        }}
      >
        <Typography variant="subtitle1" sx={{ fontWeight: '500' }}>
          {heading}
        </Typography>
      </Box>
    </a>
  );

  switch (templateID) {
    case 2:
      return renderCoverLayout('center');
    case 3:
      return renderCoverLayout('left');
    case 4:
      return renderCoverLayout('right');
    case 5:
      return renderSideLayout(false);
    case 6:
      return renderSideLayout(true);
    case 1:
    default:
      return null;
  }
}
